<template>
  <div id="ConfirmedFhutUnits" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading">
      </div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                <div class="page-title"> {{pageTitle}} </div>
                <div class="btn-groups text-right">
                  <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackCnfFhutUnit()" >
                      <i class="fp-back"> </i> Back
                  </button>
                  <button v-if="rows && rows.length > 0" type="submit" id="createHvutCostBtn" class="btn btn-primary" v-on:click.prevent="openMessageModal()">
                      <i class="fp-reload"> </i>  Update
                  </button>
                </div>
              </div>
              <div class="container-fluid">
                  <div class="">
                      <section class="internal-container border-top-table-fl">
                          <div class="purchase-order-create-main table-responsive-sm">
                              <vue-good-table
                                  ref="listConfirmedFhutUnits"
                                  title="Confirmed FHUT Units List"
                                  :columns="columns"
                                  :rows="rows"
                                  max-height="900px"
                                  :pagination-options="{
                                      enabled: true,
                                      position:'top',
                                      mode: 'records',
                                      perPage: 100,
                                      perPageDropdown:[50,100],
                                      dropdownAllowAll: false,
                                  }"
                                  :search-options="{
                                      enabled: false,
                                      placeholder: 'Search Confirmed FHUT Units',
                                  }"
                                  :select-options="{
                                      enabled: deleteConfirmFHUTUnits,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                  }"
                                  :sort-options="{
                                      enabled: true,
                                  }">
                                  <div slot="emptystate">
                                      No Data Found.
                                  </div>
                                  <div slot="selected-row-actions">
                                    <button v-if="deleteConfirmFHUTUnits" id="deleteConfirmFHUTUnits" v-on:click.prevent="DeleteConfirmFHUTUnits" class="btn btn-danger">Delete</button>
                                  </div>
                              </vue-good-table>
                          </div>
                      </section>
                      <template>
                        <div class="modal fade fhut-date-modal" id="fhut-date-modal" ref="fhutDateModal" data-backdrop="static" data-keyboard="false" aria-labelledby="fhutDateModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Add Units To FHUT</h5>
                                        <button type="button" class="close" id="btnModalFhutClose" v-on:click="hideMessageModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <p>Are you sure that you want to add Confirmed Units to FHUT for Schedule Period {{schedule}} ?</p>
                                        <div class="form-row row-cols-md-3 row-cols-3">
                                            <div class="col form-group">
                                                <label class="control-label fhut-label require">Schedule Start Date : </label>
                                                <div class="input-group">
                                                    <date-picker placeholder="MM/DD/YYYY" id="start_date" name="start_date" v-model="start_date" :config="optionsDate"></date-picker>
                                                    <label for="start_date" class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{start_date_error_msg}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="saveButtonFhut" v-on:click.prevent="updateCost()"> <i class="fp-save"> </i> Ok</button>
                                        <button class="btn btn-tertiary" id="cancelBtnFhut" v-on:click.prevent="hideMessageModal()"> <i class="fp-close"> </i>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </template>
                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';


import moment from 'moment';

export default {
    name: "ConfirmedFhutUnits",
    metaInfo() {
        return {title: "Confirmed FHUT Units List | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins],
    data: () => ({
      firstLoad: 0,
      permissions: [],
      cantAccessPage: "",
      userColumns:[],
      columns: [
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Year',
                    field: 'year',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Date In Service", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "End Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Cost',
                    field: 'hvut_cost',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

                {
                    label: 'FHUT Category',
                    field: 'hvut_category',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "FHUT Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },
                {
                    label: 'Gross Weight',
                    field: 'gvw',
                    hidden:false,
                    fpFieldType:"integer",
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Gross Weight", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                }
      ],
      totalRecords: 0,
      loading:false,
      rows:[],
      serverParams: {
          columnFilters: {},
          sort: {
              field: "id",
              type: "asc"
          },
          page: 1,
          perPage: 100
      },
      schedule:'',
      flag:"add",
      loggedinUserId: '',
      pageTitle:"Confirmed FHUT Unit List",
      schedule_date:"",
      start_date:"",
      start_date_error_msg:"",
      deleteConfirmFHUTUnits: false,
      optionsDate: {
          format: 'MM/DD/YYYY',
          useCurrent: false,
      },
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_hvut_schedule') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'delete_hvut_schedule') {
                        self.deleteConfirmFHUTUnits = true;
                    }
                }
            }
        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.loadList();
        //if user logged in than remove login button and registration button
        var userObj = localStorage.getItem("user_obj");
        if (userObj != null) {
            var userJson = JSON.parse(userObj);
            if (userJson.roles.length > 0) {
                self.loggedinUserId = userJson.id;
            }
        }
        self.getPermissions();
    },
    metaInfo() {
        return {
            title: "Confirmed FHUT Units | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
      loadList() {
          var self = this;
          self.loading = true;
          self.firstLoad = 1;

          var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              flag:self.flag,
              userId: self.loggedinUserId
          };
          $.ajax({
              url: process.env.ROOT_API + '/confirmed-hvut-units/list',
              type: "POST",
              headers: this.ajxHeaders,
              data: fields,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if (data.status == "success") {
                    if(data.content.row != ''){
                      self.rows = data.content.row.data;
                    }else{
                      self.rows = [];
                    }
                    self.totalRecords = data.content.totalRecords;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if (jqXHR.status == 0) {
                      self.errorMsg = "Remote server cannot be reached";
                  } else {
                      //redirect to login page if user not authenticated
                      if (jqXHR.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("tkn");

                          self.$router.push("/");
                      }
                      self.error = jqXHR.responseJSON.message;
                  }
              }
          });
      },

      updateCost(){
          var self = this;
          var field = [];
          var items = [];
          var error = false;
          self.start_date_error_msg = "";
          if (!self.start_date || self.start_date == null || self.start_date == "") {
              self.start_date_error_msg = "Schedule Start Date Required.";
              error = true;
          }else{
              var currentDate = new Date();
              var currentMonth = currentDate.getMonth() + 1;
              var currentYear = currentDate.getFullYear();
              if (currentMonth < 7) {
                  var previousYear = moment().subtract(1, 'years').format('Y');
                  var fhutStartDate = new Date(previousYear,6,1);
                  var fhutEndDate = new Date(currentYear,5,30);

                  if (Date.parse(self.start_date) < Date.parse(fhutStartDate) || Date.parse(self.start_date) > Date.parse(fhutEndDate)) {
                      self.start_date_error_msg = "Select Schedule Start Date According To FHUT Year.";
                      error = true;
                  }

              }else{
                  var nextYear = moment().add(1, 'years').format('Y');
                  var fhutStartDate = new Date(currentYear,6,1);
                  var fhutEndDate = new Date(nextYear,5,30);

                  if (Date.parse(self.start_date) < Date.parse(fhutStartDate) || Date.parse(self.start_date) > Date.parse(fhutEndDate)) {
                      self.start_date_error_msg = "Select Schedule Start Date According To FHUT Year.";
                      error = true;
                  }
              }
          }

          if (!error) {
              var data = this.$refs['listConfirmedFhutUnits'].selectedRows;
              var assetArr = [];
              if(data.length > 0){
                for (var i = 0; i < data.length; i++) {
                  items.push(this.$refs['listConfirmedFhutUnits'].selectedRows[i]);
                  assetArr.push(this.$refs['listConfirmedFhutUnits'].selectedRows[i].id);
                }
                field = {
                    page:self.serverParams.page,
                    perPage:self.serverParams.perPage,
                    filters:self.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    all:"selected",
                    asset:JSON.stringify(assetArr),
                    start_date:self.start_date,
                    from:self.flag,
                    userId: self.loggedinUserId,
                    rows:JSON.stringify(items)
                }

                $("#saveButtonFhut").prop("disabled", true);
                $("#cancelBtnFhut").prop("disabled", true);

                self.loading = true;

                $.ajax({
                  url: process.env.ROOT_API + "/hvut-cost/update",
                  type: "POST",
                  data: field,
                  headers: this.ajxHeaders,
                  dataType: 'json',
                  success: function (data) {
                      self.loading = false;
                      setTimeout(function () {
                      $(".alert-success").removeClass("show");
                          $(".alert-success").addClass("hide");
                      }, 10000);

                      $("#saveButtonFhut").prop("disabled", false);
                      $("#cancelBtnFhut").prop("disabled", false);

                      // self.rows = data.content.row;
                      if (data.code == '200') {
                          // self.loadList();
                          self.hideMessageModal();
                          self.$router.push('/fhut-schedule/list');
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      $("#saveButtonFhut").prop("disabled", false);
                      $("#cancelBtnFhut").prop("disabled", false);
                      if (jqXHR.status == 0) {
                          self.error = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem('user_obj');
                              localStorage.removeItem('tkn');

                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                  }
                });
              }else{
                for(var i = 0; i < self.rows.length; i++){
                    if ( self.rows[i].hvut_cost > 0){
                      items.push(self.rows[i]);
                      assetArr.push(self.rows[i].id);
                    }
                }

                field = {
                    page:self.serverParams.page,
                    perPage:self.serverParams.perPage,
                    filters:self.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    all:"yes",
                    asset:JSON.stringify(assetArr),
                    start_date:self.start_date,
                    from:self.flag,
                    userId: self.loggedinUserId,
                    rows:JSON.stringify(items)
                }

                $("#saveButtonFhut").prop("disabled", true);
                $("#cancelBtnFhut").prop("disabled", true);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/hvut-cost/update",
                    type: "POST",
                    data: field,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        setTimeout(function () {
                        $(".alert-success").removeClass("show");
                            $(".alert-success").addClass("hide");
                        }, 10000);

                        $("#saveButtonFhut").prop("disabled", false);
                        $("#cancelBtnFhut").prop("disabled", false);

                        // self.rows = data.content.row;
                        if (data.code == '200') {
                            // self.loadList();
                            self.hideMessageModal();
                            self.$router.push('/fhut-schedule/list');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#saveButtonFhut").prop("disabled", false);
                        $("#cancelBtnFhut").prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('tkn');

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
              }

          }
      },

      BackCnfFhutUnit: function(){
        var self = this;

        self.$router.push('/fhut-schedule/new');
      },

      openMessageModal() {
          var self = this;
          self.start_date = self.schedule_date;
          self.start_date_error_msg = "";
          if (!self.rows.length) {
              self.$swal('',"No Asset Available to Add to FHUT.",'info');
              return;
          }else{
              $("#fhut-date-modal").modal("show");
          }
      },

      hideMessageModal() {
          var self = this;
          $("#fhut-date-modal").modal("hide");
          self.start_date = "";
          self.start_date_error_msg = "";
      },

      DeleteConfirmFHUTUnits: function(){
        var self = this;
        self.$swal({
              title: 'Are you sure that you want to delete the selected Confirmed FHUT Units?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
          }).then((result) => {
              if (result.value) {
                var data = this.$refs['listConfirmedFhutUnits'].selectedRows;
                var use = [];

                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listConfirmedFhutUnits'].selectedRows[i].id)
                }
                // console.log("list of IDS =", use);
                self.loading = true;
                $("#deleteConfirmFHUTUnits").val("Deleting ...");
                $.ajax({
                    url: process.env.ROOT_API + "/confirmed-hvut-units/delete",
                    type: "POST",
                    data: {
                      ids: use,
                      userId: self.loggedinUserId
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        setTimeout(function () {
                          $(".alert-success").removeClass("show");
                          $(".alert-success").addClass("hide");
                        }, 10000);
                        setTimeout(function () {
                          $("#deleteConfirmFHUTUnits").val("Delete");
                        }, 10000);
                        if (data.code == 200) {
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('tkn');
                                self.$router.push("/");
                            }
                          self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

              } else {
                console.log("no");
              }
          });
      },
    }
};
</script>
<style scoped>
.right-adjust{
  width: 50%!important;
  float: right;
  height: 38px;
  padding-right: 8px;
  border-bottom: 1px solid !important;
  border-bottom-color: #8080802e !important;
}
.overClass{
  overflow: visible !important;
}

.currencyinput input {
  border: 0;
}

</style>




// WEBPACK FOOTER //
// src/components/hvut/ConfirmedFhutUnitsList.vue